<template lang="pug">
.m-card
  .m-card-header(:id="'heading-ml-' + id" :data-bs-target="'#collapse-ml-' + id" :aria-controls="'collapse-ml-' + id" data-bs-toggle='collapse' role='button' aria-expanded='false')
    .group
      .league-name {{ $tc("m.BT_ML", 1) }}
  .m-card-body.collapse.show(:id="'collapse-ml-' + id" :aria-labelledby="'heading-ml-' + id" aria-expanded='false')
    .m-card-item(:class="{ 'live' : marketType == 3 }")
      .m-card-wrap
        .odds-wrapper(v-if="mode == 0 || mode == 1")
          .m-label-wrap
            .m-label F.T  
          .odds-group
            .row
              template(v-if="details['ml'] && details['ml'][0] && details['ml'][0][5] != 0 && details['ml'][0][5] != ''")
                OddsItem.col(:odds="details['ml'][0]" idx=5 :typ="oddsType" dataType="2" :label="$t('m.ODD_Home')")
              template(v-else)
                OddsDisabled.col
              template(v-if="details['ml'] && details['ml'][0] && details['ml'][0][7] != 0 && details['ml'][0][7] != ''")
                OddsItem.col(:odds="details['ml'][0]" idx=7 :typ="oddsType" dataType="2" :label="$t('m.ODD_Away')")
              template(v-else)
                OddsDisabled.col
        .odds-wrapper(v-if="$helpers.objSize(details['mlh']) > 0 && (mode == 0 || mode == 2)")
          .m-label-wrap
            .m-label H.T  
          .odds-group
            .row
              template(v-if="details['mlh'] && details['mlh'][0] && details['mlh'][0][5] != 0 && details['mlh'][0][5] != ''")
                OddsItem.col(:odds="details['mlh'][0]" idx=5 :typ="oddsType" dataType="2" :label="$t('m.ODD_Home')")
              template(v-else)
                OddsDisabled.col
              template(v-if="details['mlh'] && details['mlh'][0] && details['mlh'][0][7] != 0 && details['mlh'][0][7] != ''")
                OddsItem.col(:odds="details['mlh'][0]" idx=7 :typ="oddsType" dataType="2" :label="$t('m.ODD_Away')")
              template(v-else)
                OddsDisabled.col



//- .card.market-card
//-   .card-header.bg-more-head.collapse-more(
//-     :id="'heading-ml-' + id"
//-     data-toggle='collapse'
//-     :data-target="'#collapse-ml-' + id"
//-     :aria-controls="'collapse-ml-' + id"
//-     aria-expanded=true
//-   )
//-     .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $tc("m.BT_ML", 1) }}
//-   .collapse.show(
//-     :aria-labelledby="'heading-ml-' + id"
//-     :id="'collapse-ml-' + id"
//-   )
//-     .card-body.p-0
//-       .market-card-content
//-         .normal(v-if="mode == 0 || mode == 1")
//-           .normal-title {{ $t("ui.full_time") }}
//-           .normal-odd-area
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 H
//-               template(v-if="details['ml'] && details['ml'][0] && details['ml'][0][5] != 0 && details['ml'][0][5] != ''")
//-                 OddsItem(:odds="details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 A
//-               template(v-if="details['ml'] && details['ml'][0] && details['ml'][0][7] != 0 && details['ml'][0][7] != ''")
//-                 OddsItem(:odds="details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
//-               template(v-else)
//-                 OddsDisabled
//-         .normal(v-if="mode == 0 || mode == 2")
//-           .normal-title {{ $t("ui.half_time") }}
//-           .normal-odd-area
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 H
//-               template(v-if="details['mlh'] && details['mlh'][0] && details['mlh'][0][5] != 0 && details['mlh'][0][5] != ''")
//-                 OddsItem(:odds="details['mlh'][0]" idx=5 :typ="oddsType" dataType="2")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 A
//-               template(v-if="details['mlh'] && details['mlh'][0] && details['mlh'][0][7] != 0 && details['mlh'][0][7] != ''")
//-                 OddsItem(:odds="details['mlh'][0]" idx=7 :typ="oddsType" dataType="2")
//-               template(v-else)
//-                 OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  }
}
</script>
